/* eslint-disable max-lines */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import { AppImages, React } from '@/app'
import { View, Text, CenterWrapper, Link, Icon, Image } from '@/components'
import { variantProvider } from '@/app/theme'

type FooterProps = any

type FooterLinksProps = {
  text?: string
  to?: string
}

const footerLinks: FooterLinksProps[] = [
  { text: 'Terms of Use', to: '/terms-and-conditions' },
  { text: 'Privacy Policy', to: '/privacy-policy' },
]

const pagesLinks: FooterLinksProps[] = [
  { text: 'Home', to: '/' },
  { text: 'About', to: '/about' },
  { text: 'Contact', to: '/contact' },
]

const currentYear = new Date().getFullYear()

export const Footer: React.FC<FooterProps> = () => {
  return (
    <View
      css={styles.wrapper}
      variants={['relative', 'fullHeight', 'justifyCenter', 'marginTop:10']}
    >
      <CenterWrapper variants={['paddingVertical:5', 'column', 'justifyStart', 'alignStart']}>
        <View variants={['fullWidth', 'justifySpaceBetween']} responsiveVariants={{ small: ['column', 'center'] }}>
          <View variants={['justifyCenter', 'alignCenter']} down={'small'}>
            <Image
              down={'small'}
              objectFit='contain'
              source={AppImages.FooterLogo}
              variants={['fullWidth', 'fullHeight', 'paddingBottom:5']}
            />
          </View>
          <View variants={['gap:4']} responsiveVariants={{ small: ['column', 'marginBottom:5'] }}>
            <View variants={['column', 'gap:1']}>
              <Text responsiveVariants={{ small: ['textCenter'] }} variants={['primarySolid200']} css={styles.footerText} text={'Pages'} />
              {pagesLinks.map(el => <Link responsiveVariants={{ small: ['textCenter'] }} variants={['primarySolid200', 'bold']} key={el?.text} text={el?.text} to={el?.to} />)}
            </View>
            <View variants={['column', 'gap:1']}>
              <Text responsiveVariants={{ small: ['textCenter'] }} variants={['primarySolid200']} css={styles.footerText} text={'Terms & Conditions'} />
              {footerLinks.map(el => <Link responsiveVariants={{ small: ['textCenter'] }} variants={['primarySolid200', 'bold']} key={el?.text} text={el?.text} to={el?.to} />)}
            </View>
          </View>
          <View variants={['column', 'gap:1']}>
            <Text variants={['primarySolid200']} responsiveVariants={{ small: ['alignSelfCenter'] }} text={'customerservices@cherrydating.co.uk'} />
            <Text variants={['primarySolid200', 'alignSelfEnd']} responsiveVariants={{ small: ['alignSelfCenter'] }} text={`©${currentYear} Cherry Ltd.`} />
            <Text variants={['primarySolid200', 'alignSelfEnd']} responsiveVariants={{ small: ['alignSelfCenter'] }} text={'Made with ♥️  in London, UK'} />
          </View>
        </View>
        <View variants={['marginVertical:4']} style={styles.separator} />
        <View
          variants={['row', 'justifySpaceBetween', 'fullWidth', 'gap:5']}
          responsiveVariants={{ small: ['column', 'center'] }}
        >
          <View variants={['column', 'gap:1']}>
            <Text
              responsiveVariants={{ small: ['textCenter'] }}
              css={styles.footerText}
              variants={['primarySolid50']}
              text={'Cherry Ltd. is registered in England & Wales, company no. 13734947.'}
            />
            <Text
              responsiveVariants={{ small: ['textCenter'] }}
              css={styles.footerText}
              variants={['primarySolid50']}
              text={'This website uses third-party assets and software. By using our website you agree to the terms of use.'}
            />
          </View>
          <View
            variants={['gap:2']}
            responsiveVariants={{ small: ['marginTop:3'] }}
          >
            <Link to={'https://www.facebook.com/people/Cherry-Dating/61550739111031/'}>
              <Icon name={'facebook'} />
            </Link>
            <Link to={'https://www.instagram.com/cherry_datinguk/?hl=it'}>
              <Icon name={'instagram'} />
            </Link>
          </View>
        </View>
      </CenterWrapper>
    </View>

  )
}

const SEPARATOR_HEIGHT: Number = 2

const styles = variantProvider.createComponentStyle(
  (theme) => ({
    wrapper: {
      backgroundColor: theme.colors.primarySolid600,
    },
    separator: {
      backgroundColor: theme.colors.primarySolid200,
      height: SEPARATOR_HEIGHT,
      ...theme.presets.fullWidth,
    },
    footerText: {
      fontSize: 14,
      lineHeight: 1.49,
      fontWeight: 400,
    },
  }),
  true,
)
